import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
  path: '/servicio/:nombre',
  name: 'Servicio',
  component: () => import('@/views/Servicio.vue'),
},
{
  path: '/trabajo/:id',
  name: 'Trabajo',
  component: () => import('@/views/Trabajo.vue'),
},
{
  path: "/registro",
  name: "RegistroUsuario",
  component: () => import("../views/RegistroUsuario.vue"),
},
{
  path: "/addService",
  name: "addService",
  component: () => import("../views/AddServiceView.vue"),
},
{
  path: "/trabajosRealizados",
  name: "TrabajosRealizados",
  component: () => import("../views/TrabajosRealizados.vue"),
},
{
  path: "/Calculador",
  name: "Calculador",
  component: () => import("../views/Calculador.vue"),
},
{
  path: "/login",
  name: "Login",
  component: () => import("../views/Login.vue"),
},
{
  path: "/admin/usuarios",
  name: "AdminUsuarios",
  component: () => import("../views/AdminUsuarios.vue"),
},
{
  path: "/perfil",
  name: "MiPerfil",
  component: () => import("../views/MiPerfil.vue"),
},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
